import { render, staticRenderFns } from "./abilitySpark.vue?vue&type=template&id=386e9098&scoped=true"
import script from "./abilitySpark.vue?vue&type=script&lang=js"
export * from "./abilitySpark.vue?vue&type=script&lang=js"
import style0 from "./abilitySpark.vue?vue&type=style&index=0&id=386e9098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e9098",
  null
  
)

export default component.exports